import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';
import styled from 'styled-components';
import { layout } from 'styled-system';

export default function Tooltip({
  children,
  tooltip,
  hideArrow,
  zIndex,
  ...props
}) {
  return (
    <TooltipTrigger
      {...props}
      tooltip={({
        arrowRef,
        tooltipRef,
        getArrowProps,
        getTooltipProps,
        placement,
      }) => (
        <Container
          {...getTooltipProps({
            ref: tooltipRef,
          })}
          zIndex={zIndex}
        >
          {!hideArrow && (
            <div
              {...getArrowProps({
                ref: arrowRef,
                className: 'tooltip-arrow',
                'data-placement': placement,
              })}
            />
          )}
          {tooltip}
        </Container>
      )}
    >
      {({ getTriggerProps, triggerRef }) => (
        <InnerContainer
          {...getTriggerProps({
            ref: triggerRef,
            className: 'trigger',
          })}
        >
          {children}
        </InnerContainer>
      )}
    </TooltipTrigger>
  );
}

Tooltip.defaultProps = {
  zIndex: 10,
};

const Container = styled.div`
  ${layout}
  transition: opacity 0.3s;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.font.primary};
  margin: 0.4rem;
  padding: 0.4rem;
  z-index: ${props => props.zIndex};

  .tooltip-arrow {
    height: 1rem;
    position: absolute;
    width: 1rem;
  }

  .tooltip-arrow::before {
    border-style: solid;
    content: '';
    display: block;
    height: 0;
    margin: auto;
    width: 0;
  }

  .tooltip-arrow::after {
    border-style: solid;
    content: '';
    display: block;
    height: 0;
    margin: auto;
    position: absolute;
    width: 0;
  }

  .tooltip-arrow[data-placement*='bottom'] {
    height: 1rem;
    left: 0;
    margin-top: -0.4rem;
    top: 0;
    width: 1rem;
  }

  .tooltip-arrow[data-placement*='bottom']::before {
    border-color: transparent transparent #ebebeb transparent;
    border-width: 0 0.5rem 0.4rem 0.5rem;
    position: absolute;
    top: -1px;
  }

  .tooltip-arrow[data-placement*='bottom']::after {
    border-color: transparent transparent white transparent;
    border-width: 0 0.5rem 0.4rem 0.5rem;
  }

  .tooltip-arrow[data-placement*='top'] {
    bottom: 0;
    height: 1rem;
    left: 0;
    margin-bottom: -1rem;
    width: 1rem;
  }

  .tooltip-arrow[data-placement*='top']::before {
    border-color: #ebebeb transparent transparent transparent;
    border-width: 0.4rem 0.5rem 0 0.5rem;
    position: absolute;
    top: 1px;
  }

  .tooltip-arrow[data-placement*='top']::after {
    border-color: white transparent transparent transparent;
    border-width: 0.4rem 0.5rem 0 0.5rem;
  }

  .tooltip-arrow[data-placement*='right'] {
    height: 1rem;
    left: 0;
    margin-left: -0.7rem;
    width: 1rem;
  }

  .tooltip-arrow[data-placement*='right']::before {
    border-color: transparent #ebebeb transparent transparent;
    border-width: 0.5rem 0.4rem 0.5rem 0;
  }

  .tooltip-arrow[data-placement*='right']::after {
    border-color: transparent white transparent transparent;
    border-width: 0.5rem 0.4rem 0.5rem 0;
    left: 6px;
    top: 0;
  }

  .tooltip-arrow[data-placement*='left'] {
    height: 1rem;
    margin-right: -0.7rem;
    right: 0;
    width: 1rem;
  }

  .tooltip-arrow[data-placement*='left']::before {
    border-color: transparent transparent transparent #ebebeb;
    border-width: 0.5rem 0 0.5rem 0.4em;
  }

  .tooltip-arrow[data-placement*='left']::after {
    border-color: transparent transparent transparent white;
    border-width: 0.5rem 0 0.5rem 0.4em;
    left: 3px;
    top: 0;
  }
`;
const InnerContainer = styled.span`
  cursor: pointer;
`;
